import React from 'react';
import type { DrawerContentCardItem } from './DrawerContentCard';

export interface DrawerContentListProps {
  list: DrawerContentCardItem[];
}

/**
 * DrawerContentList — renders key/value rows as a flat list separated by lines.
 *
 * Same item shape as DrawerContentCard but without the card border/background.
 * Items with `hidden: true` are filtered out automatically.
 */
export const DrawerContentList: React.FC<DrawerContentListProps> = ({
  list,
}) => {
  const visibleItems = list.filter(item => !item.hidden);
  if (visibleItems.length === 0) return null;

  return (
    <div className="divide-y divide-gray-100">
      {visibleItems.map((item, i) => (
        // `items-start` + a real gap keeps a long value (an address, a
        // legal name) from crowding into its label: the label holds its
        // width and the value wraps in the space that's left.
        <div key={i} className="flex items-start justify-between gap-4 py-3.5">
          <span className="flex-none pt-px text-sm text-muted-foreground">{item.label}</span>
          <span className="min-w-0 break-words text-end text-sm font-medium text-gray-900">
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
};
